import React from "react"
import { IPageCommunityTab, PageLayoutTabs } from "@organic-return/foundation-react/src/components/PageLayouts/PageLayoutTabs"
import { useSiteContext } from "../common/SiteContext"
import { graphql, useStaticQuery } from "gatsby"

const CommunitiesContentWithTabs = ({ module }) => {
  const data = useStaticQuery(graphql`
    query {
        allAgilityCommunitiesContentWithTabs {
            nodes {
              contentID              
              contentTabs {
                customFields {
                  title
                  firstSectionTitle
                  firstSectionHeadline
                  firstSectionText
                  firstSectionImage {
                    url
                  }
                  firstSectionCTA {
                    href
                    text
                  }
                  carouselBottomLinkText
                  carouselBottomLinkUrl
                  developmentsSectionSubheadline
                  developmentsSectionText
                  developmentsSectionTitle
                  marketStatsCTA {
                    href
                    text
                  }
                }
                properties {
                  itemOrder
                }
                listings {
                  defaultImage {
                    url
                    caption
                    dimensions
                  }
                  address {
                    text
                    street1
                    street2
                    city
                    state
                    postal
                  }
                  path
                  flags
                  price
                  priceSuffix
                  baths
                  bathsHalf
                  baths_3_4
                  beds
                  sleeps
                  sqft
                  lotacres
                  mlsID
                }
                developments {
                  customFields {
                    description
                    name
                    image {
                      url
                    }
                  }
                  path
                  properties {
                    itemOrder
                  }
                }
                filter {
                  customFields {
                    query
                  }
                }
                marketStatsJSON
              }
            }
          }
    }
  `)

  const sortByItemOrder = (a, b) => a.properties.itemOrder - b.properties.itemOrder

  const filteredData = data.allAgilityCommunitiesContentWithTabs?.nodes?.find((item) => {
    return item.contentID == module.contentID
  })

  const contentTabs = filteredData?.contentTabs?.sort(sortByItemOrder)

  let tabsContents: IPageCommunityTab[] = contentTabs?.map((tab): IPageCommunityTab => {
    const fields = tab.customFields
    const hasCommunitiesContent = fields.firstSectionTitle && fields.firstSectionHeadline && fields.firstSectionText && fields.firstSectionImage?.url
    const hasDevelopmentsContent = fields.developmentsSectionTitle && fields.developmentsSectionText
    return {
      label: fields.title,
      content: {
        listings: tab.listings?.slice(0, 10),
        communities: hasCommunitiesContent && ({
          header: fields.firstSectionTitle,
          headline: fields.firstSectionHeadline,
          content: fields.firstSectionText,
          image: { url: fields.firstSectionImage.url },
          callToAction: fields.firstSectionCTA?.href && { label: fields.firstSectionCTA?.text, url: fields.firstSectionCTA.href }
        }),
        developments: hasDevelopmentsContent && ({
          headline: fields.developmentsSectionTitle,
          subheadline: fields.developmentsSectionSubheadline,
          text: fields.developmentsSectionText,
          carouselItems: tab.developments?.sort(sortByItemOrder)?.map((item) => {
            return {
              title: item.customFields.name,
              content: item.customFields.description,
              image: { url: item.customFields.image?.url },
              link: { url: item.path, label: "View Development" }
            }
          }),

        }),
        marketStatsJSON: tab.marketStatsJSON,
        marketStatsCTA: fields.marketStatsCTA?.href && ([{
          label: fields.marketStatsCTA?.text,
          url: fields.marketStatsCTA.href
        }]),
        tabFilter: tab.filter?.[0]?.customFields?.query && (JSON.parse(decodeURIComponent(tab.filter[0].customFields.query))),
        carouselBottomLinkText: fields.carouselBottomLinkText,
        carouselBottomLinkUrl: fields.carouselBottomLinkUrl
      }
    }
  })

  tabsContents = tabsContents.filter((tab) => tab.content.listings.length > 0 || tab.content.communities || tab.content.developments || tab.content.marketStatsJSON)

  const siteContext = useSiteContext()

  return (
    <PageLayoutTabs
      tabsContent={tabsContents}
      {...siteContext.globalCommunitiesContentWithTabsProps}
    />
  )
}

export default CommunitiesContentWithTabs
